// Web and macOS do not load the mobile Expo updater.
export default function MobileUpdateGate({ children }) { return children; }
